(() => {
  const form = document.querySelector('[data-groomsmen-form]');
  const photo = document.querySelector('#GroomsmenPhoto');
  const enlarge = document.querySelector('[data-groomsmen-enlarge]');
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-groomsmen-photo]');
    if (!button || !photo) return;
    photo.src = button.dataset.groomsmenPhoto;
    photo.alt = button.querySelector('img').alt;
    if (enlarge) enlarge.href = button.dataset.groomsmenPhoto;
    document.querySelectorAll('[data-groomsmen-photo]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
  });
  if (!form) return;
  const review = document.querySelector('[data-groomsmen-review]');
  const initials = form.querySelector('[data-groomsmen-initials]');
  const quantity = form.querySelector('[name="quantity"]');
  const color = form.querySelector('[data-groomsmen-initial-color]');
  const otherWrap = form.querySelector('[data-groomsmen-other-wrap]');
  const other = form.querySelector('[data-groomsmen-other]');
  const entries = () => initials.value.trim().split(/[,;\n]+/).map((value) => value.trim()).filter(Boolean);
  const validate = () => {
    const values = entries();
    const invalidLetter = values.some((value) => !/^[A-Za-z]$/.test(value));
    const countMismatch = values.length !== Number(quantity.value);
    initials.setCustomValidity(!initials.value.trim() ? 'Enter one initial for every towel.' : invalidLetter ? 'Enter one letter for each towel, separated by commas.' : countMismatch ? `Enter ${quantity.value} initial${Number(quantity.value) === 1 ? '' : 's'} to match the quantity.` : '');
    const isOther = color.value === 'Other';
    otherWrap.hidden = !isOther;
    other.required = isOther;
    other.setCustomValidity(isOther && !other.value.trim() ? 'Enter the requested initial color.' : '');
  };
  for (const name of ['input', 'change']) form.addEventListener(name, () => { validate(); if (review) review.hidden = true; });
  form.addEventListener('submit', (event) => {
    validate();
    if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
    if (!form.hasAttribute('data-preview-groomsmen')) return;
    event.preventDefault();
    review.replaceChildren();
    const data = new FormData(form);
    const add = (tag, text) => { const element = document.createElement(tag); element.textContent = text; review.append(element); };
    add('h2', 'Your personalized groomsmen towel set');
    for (const [key, value] of data) {
      if (key === 'properties[Personalization confirmed]' || !String(value).trim()) continue;
      add('p', `${key.replace(/^properties\[/, '').replace(/\]$/, '')}: ${String(value).trim()}`);
    }
    add('p', `Item subtotal: $${(23.99 * Number(data.get('quantity'))).toFixed(2)} USD`);
    add('p', 'Preview only — nothing has been ordered or saved. Shipping and taxes are not included.');
    review.hidden = false;
    review.focus();
  });
})();
